document.addEventListener('DOMContentLoaded', () => {
  // Seleziona tutti gli elementi input sulla pagina
  const inputElements = document.querySelectorAll('input');
  const valueClass = 'has-value';

  // Aggiungi il controllo e l'evento input a ogni input
  inputElements.forEach(input => {
    input.addEventListener('input', (event) =>  {
      if (event.currentTarget.value) {
        event.currentTarget.classList.add(valueClass);
      } else {
        event.currentTarget.classList.remove(valueClass);
      }
    });
  });
});
